var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullets"},_vm._l((_vm.steps),function(item,index){return _c('a',{key:index,staticClass:"bullet",class:{ '-active': _vm.activeStep === index + 1 },attrs:{"href":"#"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }